import HistoricalDocuments from 'components/PatientDiagnosisDrawer/components/documents/HistoricalDocuments'
import { getAllDocumentUrl, getPatientDetail } from 'core/services/api'
import React, { useState, useEffect } from 'react'

function Temporary() {
  const [patientId, setPatientId] = useState<any>()
  const [details, setDetails] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = () => {
    // setLoading(true);
    setError(null);
    getPatientDetail(patientId)
      .then((res: any) => {
        console.log(res, "ressss");
        setDetails(res);
      })
      .catch((err: any) => {
        setError("Error fetching patient details");
      })
      .finally(() => {
        setLoading(false);
      });
  }





  const handleInputChange = (e: any) => {
    setPatientId(e);
  }

  return (
    <>
      <input type='text' onChange={(evnt) => handleInputChange(evnt.target.value)} />
      <button onClick={handleSubmit}>Submit</button>



      {loading && <div>Loading...</div>}
      {error && <div>Error: {error}</div>}
      {console.log(details, "details")}
      {details ? (
        <div className="document-RMO">
          <HistoricalDocuments patient={details} />
        </div>
      ) : (
        <div>No Document Available</div>
      )}
    </>
  );
}

export default Temporary;
